<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="col-lg-11">
        <b-form @submit.stop.prevent="onSubmit">
         
          <div v-if="this.show_image_gallery == 1">
            <b-row class="mb-5">
              <b-col sm="12">
                <UploadImages v-if="images_path.length == 0" @change="handleImages" :max="15" uploadMsg="upload images"
                  fileError="images files only accepted" />
                <UploadImages v-if="images_path.length > 0" @change="handleImages" :max="15"
                  uploadMsg="upload product images" fileError="images files only accepted" :images_path="images_path" />
               
              </b-col>
            </b-row>
          </div>
          <p> รูปภาพ พาโนราม่า</p>
          <div v-if="this.show_image_galleryPano == 1">
            <b-row class="mb-5">
              <b-col sm="12">
                <UploadImages v-if="images_path_pano.length == 0" @change="handleImagesPano" :max="15" uploadMsg="upload images"
                  fileError="images files only accepted" />
                <UploadImages v-if="images_path_pano.length > 0" @change="handleImagesPano" :max="15"
                  uploadMsg="upload product images" fileError="images files only accepted" :images_path="images_path_pano" />
              
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col sm="12">
              <b-button type="submit" variant="primary" class="float-right mr-3">{{  $t("PAGE.DEFAULT.FORM.BTN_SUBMIT") 
                }}</b-button>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<style>
.imgSize {
  margin-left: 30%;
  padding-top: 0.5cm;
  width: 30%;
  height: 30%;
  padding-bottom: 0.5cm;
}

.ckeditorFieldRequired {
  color: red;
}

.RequiredColor {
  color: red;
}
</style>

<script>
import { validationMixin } from "vuelidate";
import Swal from "sweetalert2";
import {
  GET_GALLERY_DATA,
  POST_GALLERY_DATA,
  PUT_GALLERY_DATA,
  POST_GALLERY_PANO_DATA,
  GET_GALLERY_PANO_DATA,
  PUT_GALLERY_PANO_DATA
} from "@/core/services/store/gallery.module";
import { mapState } from "vuex";
import UploadImages from "@/assets/plugins/vue-upload-multiple-images/vue-upload-multiple-images.vue";

export default {
  mixins: [validationMixin],
  components: {
    UploadImages
  },
  data() {
    return {
      form: {
        gallery_image: []
      },
      data:'',
      preview: null,
      pano_status: false,
      img_status: false,
      images_path_pano:[],
      images_path: [],
      gallery_image_required: false,
      show_image_gallery: 0,
      show_image_galleryPano:0,
      id: 0,
      id_pano: 0,
      mangrove_location_id: 0
    };
  },
  validations: {

  },
  computed: {
    ...mapState({})
  },
  mounted() {
    this.mangrove_location_id = this.$route.params.id
    if (this.mangrove_location_id > 0) {
      this.get(this.mangrove_location_id);
      this.getPano(this.mangrove_location_id);
      //this.getPano(this.mangrove_location_id);
    } else {
      this.show_image_gallery = 1;
    }
  },
  methods: {
    onSubmit() {
      if (this.pano_status) {
        let formDataPano = new FormData();
        formDataPano.append("mangrove_location_id", this.$store.state.mangrove_location.data_pram.mangrove_location_id);

        formDataPano.append("imageLength", this.form.gallery_image_pano.length);
        formDataPano.append("status_image", 1);
        for (let i = 0; i < this.form.gallery_image_pano.length; i++) {
          formDataPano.append("images", this.form.gallery_image_pano[i]);
        }

        if (this.id_pano > 0) {
          this.updatePano(this.id_pano, formDataPano);
        } else {
          this.createPano(formDataPano);
        }
      }

      if (this.img_status) {
        let formData = new FormData();
        formData.append("mangrove_location_id", this.$store.state.mangrove_location.data_pram.mangrove_location_id);
        formData.append("imageLength", this.form.gallery_image.length);
        formData.append("status_image", 0);
        for (let i = 0; i < this.form.gallery_image.length; i++) {
          formData.append("images", this.form.gallery_image[i]);
        }
        if (this.id > 0) {
          this.update(this.id, formData);
        } else {
          this.create(formData);
        }

      }

    },
    get(id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(GET_GALLERY_DATA, { id })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success") {
                if (data.data) {
                  this.id = data.data.id

                  for (const formKey of Object.keys(this.form)) {
                    for (const dataKey of Object.keys(data.data)) {
                      if (formKey === dataKey) {
                        this.form[formKey] = data.data[formKey];
                      }
                    }
                  }
                  for (let i = 0; i < this.form.gallery_image.length; i++) {
                    this.images_path.push(
                      `${process.env.VUE_APP_IMAGE}${this.form.gallery_image[i].image}`
                    );
                  }

                  this.show_image_gallery = 1;
                }
                else {
                  this.show_image_gallery = 1;
                }
                setTimeout(() => {
                  this.$v.$reset();
                }, 50);
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });

    },
    updatePano(id, data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(PUT_GALLERY_PANO_DATA, { id, data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    createPano(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(POST_GALLERY_PANO_DATA, { data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                this.mangrove_location_id = data.data.mangrove_location_id
                this.id_pano = data.data.id
                Swal.fire({
                  icon: "success",
                  text: `สร้างข้อมูลเรียบร้อยแล้ว`,
                  confirmButtonColor: '#840000'
                });
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    getPano(id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(GET_GALLERY_PANO_DATA, { id })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success") {
                if (data.data) {
                  this.id_pano = data.data.id

                  let gallery_image_pano = data.data.gallery_image
                  for (let i = 0; i < gallery_image_pano.length; i++) {
                    this.images_path_pano.push(
                      `${process.env.VUE_APP_IMAGE}${gallery_image_pano[i].image}`
                    );
                  }
                 

                  this.show_image_galleryPano = 1;
                }
                else {
                  this.show_image_galleryPano = 1;
                }
                setTimeout(() => {
                  this.$v.$reset();
                }, 50);
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });

    },
    create(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(POST_GALLERY_DATA, { data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                this.mangrove_location_id = data.data.mangrove_location_id
                this.id = data.data.id
                Swal.fire({
                  icon: "success",
                  text: `สร้างข้อมูลเรียบร้อยแล้ว`,
                  confirmButtonColor: '#840000'
                });
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    update(id, data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(PUT_GALLERY_DATA, { id, data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    handleImages(files) {
      this.img_status= true
      this.open_img = true
      this.form.gallery_image = files;
      this.gallery_image_required = false;
    },
    handleImagesPano(files) {
      this.open_imgpano = true
      this.pano_status = true
      this.form.gallery_image_pano = files;
      this.gallery_image_required_pano = false;
    },
    openURL(link) {
      window.open(link);
    }
  }
};
</script>
